import "@/components/brand.css";

// LOCKED brand (see /app/memory/BRAND_LOGO_LOCK.md): only the master PNGs, never redraw in CSS/SVG.
const SRC = { header: "/branding/master/nbacube-header.png?v=3", footer: "/branding/master/nbacube-footer.png?v=3" };

export const BrandLogo = ({ size = "lg", tagline = false }) => (
  <span className={`nbc-brand nbc-brand-${size}${tagline ? " nbc-brand-footer" : ""}`} data-testid="brand-logo">
    <img src={tagline ? SRC.footer : SRC.header} alt="NBACUBE" draggable={false} />
  </span>
);
